<script>
import TaxReturnTableRow from "@/components/accountants/tax_return/table/TaxReturnTableRow.vue";
import TaxReturnTable from "@/components/accountants/tax_return/table/TaxReturnTable.vue";
import TaxReturnTableHeader from "@/components/accountants/tax_return/table/TaxReturnTableHeader.vue";

export default {
  name: "TaxReturnAdvancementsSection",
  components: {TaxReturnTableHeader, TaxReturnTable, TaxReturnTableRow},
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <TaxReturnTable>
    <template v-slot:header>
      <TaxReturnTableHeader/>
    </template>

    <template v-slot:body>
      <TaxReturnTableRow :description="$gettext('Vordering omzetbelasting')"
                         :calculated-value="data.calculated.balance_active_claim_bruto"
                         v-model="data.edit.balance_active_claim_bruto"/>

      <TaxReturnTableRow :description="$gettext('Vorderingen op handelsdebiteuren')"
                         :calculated-value="data.calculated.balance_active_claim_debit"
                         v-model="data.edit.balance_active_claim_debit"/>

      <TaxReturnTableRow :description="$gettext('Overige vorderingen')"
                         :calculated-value="data.calculated.balance_active_claim_other"
                         v-model="data.edit.balance_active_claim_other"/>
    </template>
  </TaxReturnTable>
</template>

<style scoped lang="scss">

</style>